export default "<ion-header>\n  <ion-toolbar>\n    <ion-title>devolution</ion-title>\n  </ion-toolbar>\n</ion-header>\n\n<ion-content>\n\n</ion-content>\n"